import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="header-search"
//
// Expand/collapse the desktop header search. The collapsed form is
// `visibility: hidden` (see header.scss), which keeps it out of the tab order,
// so the toggle button is the only control until the form is opened.
export default class extends Controller {
  static targets = ["form", "input", "toggle"]

  connect() {
    this.setOpen(false)
  }

  toggle(event) {
    event.preventDefault()

    if (!this.isOpen) {
      this.open()
      return
    }

    // Open with a query: submit. requestSubmit() fires the submit event, so
    // Turbo and native validation both still apply — form.submit() skips them.
    if (this.hasInputTarget && this.inputTarget.value.trim()) {
      this.formTarget.requestSubmit()
      return
    }

    this.close()
  }

  open() {
    this.setOpen(true)

    // Flush the class change so the form computes to visibility:visible before
    // we focus — focus() is a no-op on a hidden element. header.scss keeps
    // `visibility` out of the transition so this flip is immediate.
    void this.formTarget.offsetWidth

    if (this.hasInputTarget) this.inputTarget.focus()
  }

  close() {
    if (!this.isOpen) return

    // Focus would otherwise be stranded on a visibility:hidden input.
    const hadFocus = this.hasInputTarget && this.element.contains(document.activeElement)

    this.setOpen(false)

    if (hadFocus && this.hasToggleTarget) this.toggleTarget.focus()
  }

  setOpen(isOpen) {
    this.isOpen = isOpen
    // .search__form already carries a 0.3s transition, so toggling .show
    // animates on its own.
    this.formTarget.classList.toggle("show", isOpen)

    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", String(isOpen))
      this.toggleTarget.setAttribute("aria-label", isOpen ? "Submit search" : "Search")
    }
  }
}
